module.exports = __webpack_public_path__ + "img/newPeopleVipReceive.23d66e57.png";